import React, { forwardRef } from 'react';
const LinkedIn = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 24 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("path", { d: "M22.206 0H1.794C.822 0 0 .75 0 1.725v20.55C0 23.25.822 24 1.794 24h20.412c.972 0 1.794-.75 1.794-1.725V1.725C24 .75 23.178 0 22.206 0zM3.589 9h3.514v11.475H3.589zm1.794-1.575c-1.121 0-2.093-.9-2.093-2.1a2.093 2.093 0 1 1 4.187 0c0 1.2-.972 2.1-2.094 2.1zm15.103 13.05h-3.514v-5.55c0-1.35 0-3-1.87-3-1.868 0-2.093 1.425-2.093 2.925v5.7H9.495V9h3.44v1.575h.074c.449-.9 1.645-1.875 3.365-1.875 3.589 0 4.262 2.4 4.262 5.475v6.3z", fill: "currentColor" }))));
LinkedIn.displayName = 'LinkedIn';
// @ts-ignore;
const iconData = {
    glyph: LinkedIn,
    group: 'social',
};
export default iconData;
